<template>
  <div v-if="parte.folio > 0" :class="['parte-card', parte.seleccionado ? 'parte-selected' : '']">
    <!-- HEADER -->
    <div class="parte-card-header" @click="clickTicket">
      <h4 class="card-title text-white">Folio {{ parte.folio }} {{ textito }}</h4>
    </div>

    <!-- BODY -->
    <div class="parte-card-body">
      <div class="parte-table-container">
        <table class="parte-table">
          <tbody>
            <tr>
              <td>Cliente:</td>
              <td>{{ parte.empresa ? parte.empresa.razon_social : '-' }}</td>
            </tr>
            <tr>
              <td>Origen:</td>
              <td>{{ parte.origen ? parte.origen.nombre : '-' }} ({{ parte.tipo_origen_texto || '-' }})</td>
            </tr>
            <tr>
              <td>Destino:</td>
              <td>{{ parte.destino ? parte.destino.nombre : '-' }} ({{ parte.tipo_destino_texto || '-' }})</td>
            </tr>
            <tr>
              <td>Recalada:</td>
              <td>{{ parte.recalada ? moment(parte.recalada).format('DD-MM-YYYY HH:mm') : '-' }}</td>
            </tr>
            <tr>
              <td>Amarre Jaula:</td>
              <td>{{ parte.atraco_fondeo ? moment(parte.atraco_fondeo).format('DD-MM-YYYY HH:mm') : '-' }}</td>
            </tr>
            <tr>
              <td>Inicio:</td>
              <td>{{ parte.inicio_faena ? moment(parte.inicio_faena).format('DD-MM-YYYY HH:mm') : '-' }}</td>
            </tr>
            <tr>
              <td>Termino:</td>
              <td>{{ parte.termino_faena ? moment(parte.termino_faena).format('DD-MM-YYYY HH:mm') : '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.parte-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 50, 0.25);
  max-width: 460px;
  transition: transform 0.2s ease, box-shadow 0.3s ease, border 0.3s ease;
  border: 2px solid transparent; /* borde invisible por defecto */
}
.parte-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 50, 0.35);
}

/* CARD SELECCIONADO */
.parte-selected {
  border: 2px solid #337fd9; /* borde azul brillante */
  box-shadow: 0 0 12px rgba(51, 127, 217, 0.6); /* glow azul */
}

/* HEADER */
.parte-card-header {
  background: linear-gradient(135deg, #0d1f45, #337fd9);
  padding: 12px 16px;
  cursor: pointer;
  text-align: left;
}
.parte-card-header .card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

/* BODY */
.parte-card-body {
  padding: 14px 16px;
}

/* TABLE */
.parte-table-container {
  width: 100%;
}
.parte-table {
  width: 100%;
  border-collapse: separate;
}
.parte-table td {
  padding: 2px 8px;
  font-size: 14px;
  text-align: left;
  background: #f7f9fc;
  border-radius: 6px;
}
.parte-table td:first-child {
  font-weight: 600;
  color: #0d1f45;
  width: 35%;
  background: transparent;
}
</style>

<script>
export default {
  props: ['parte'],
  computed: {
    textito() {
      if ([1,3,4].includes(this.parte.tipopartes_id)) {
        return this.parte.es_descarga == 0 ? '(CARGA)' : '(TRASLADO/DESCARGA)';
      }
      if ([5,6].includes(this.parte.tipopartes_id)) {
        return '(CARGA/DESCARGA)';
      }
      return '';
    }
  },
  methods: {
    clickTicket() {
      this.$emit('clicked', this.parte);
    }
  }
};
</script>
